import { ItemListRendererProps as BlueprintItemListRendererProps } from '@blueprintjs/select';
import * as React from 'react';

import { Loading } from 'bones/design-system/components/Loading';
import { MenuItems } from 'bones/design-system/components/select/MenuItems';
import { Body } from 'bones/design-system/components/typography/Body';
import { SelectItem } from 'bones/design-system/utils/select/types';

export const loadingRenderer =
  <
    SubItemType extends SelectItem | null,
    ItemType extends SelectItem<SubItemType>
  >({
    loadingTestId,
  }: {
    loadingTestId?: string;
  }) =>
  // eslint-disable-next-line react/display-name
  ({ itemsParentRef }: BlueprintItemListRendererProps<ItemType>) =>
    (
      <MenuItems ulRef={itemsParentRef}>
        <div className="vb-selector-loading" data-testid={loadingTestId}>
          <Loading size="sm" />
          <Body size="md">Loading...</Body>
        </div>
      </MenuItems>
    );
